var React = require('react');

function Download (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#5147DC","fillRule":"nonzero"},[React.createElement("path",{"d":"M9.75 7.15l-.91-.91-1.69 1.69V0h-1.3v7.93L4.16 6.24l-.91.91L6.5 10.4z","key":0}),React.createElement("path",{"d":"M11.7 7.8v3.9H1.3V7.8H0V13h13V7.8z","key":1})]));
}

Download.displayName = "Download";

Download.defaultProps = {"width":"13","height":"13"};

module.exports = Download;

Download.default = Download;
